<div
    *ngFor="let section of model?.sections"
    class="row m-0"
    [style.backgroundColor]="section.backgroundColor"
    [style.color]="section.textColor"
    [style.paddingTop]="section.padding?.top + 'px'"
    [style.paddingBottom]="section.padding?.bottom + 'px'"
    [style.paddingLeft]="section.padding?.left + 'px'"
    [style.paddingRight]="section.padding?.right + 'px'">
    <div
        *ngFor="let column of section?.columns"
        class="col-12 col-md-{{(section.footerLayoutType | columnResponsive : column.index)}}"
        [style.paddingTop]="column.padding?.top + 'px'"
        [style.paddingBottom]="column.padding?.bottom + 'px'"
        [style.paddingLeft]="column.padding?.left + 'px'"
        [style.paddingRight]="column.padding?.right + 'px'">
        <ng-container *ngIf="column.translations | filterLanguage: language">
            <div [innerHtml]="(column.translations | filterLanguage: language) | keepHtml"></div>
        </ng-container>
    </div>
</div>
<!-- [style.width]="(section.footerLayoutType | columnWidth : column.index) + '%'" -->